import LayoutContainer from 'components/Common/LayoutContainer'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { FlightCampaignsCard } from './FlightCampaignsCard'
import { mediaQueryUp } from 'components/utils/breakpoint'

const CampaignsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${rem(28)};
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }
`

interface Props {
  campaigns: Array<App.FlightCampaign>
}

export function FlightCampaigns(props: Props) {
  const { campaigns } = props

  return (
    <LayoutContainer>
      <CampaignsContainer>
        {campaigns.map(campaign => (
          <FlightCampaignsCard
            key={campaign.id}
            title={campaign.title}
            endDate={campaign.end_date}
            subTitle={campaign.header}
            logoUrl={campaign.airline_logo}
            heroImageId={campaign.hero_image_public_id}
            id={campaign.id}
          />
        ))}
      </CampaignsContainer>
    </LayoutContainer>
  )
}
